import React, { Component } from "react";
import { Chart } from "react-google-charts";
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';

import {
  TextField,
  Autocomplete,
  createFilterOptions,
  // Box,
  // Paper,
  Checkbox,
  // FormControlLabel,
  // Divider
} from "@mui/material";
import "./contact.css";
import { SemipolarLoading } from "react-loadingg";
import { connect } from "react-redux";
import { API_URL } from "../../config";
import "./CompanyDetailsTab.css";
import ConnectRateIcon from "../assets/marketing.svg";
import TotalEngagedIcon from "../assets/market.svg";

import TotalLeadIcon from "../assets/target.svg";
import TotalinvitesentIcon from "../assets/invitesent.png";

import colorLib from "@kurkle/color";
//import { Line, Pie } from "react-chartjs-2";
import TriggersCard from "../Card/TriggersCard";
import LeadsCard from "../Card/LeadsCard";
import ContactsCard from "../Card/ContactsCard";
import EngagementCard from "../Card/EngagementCard";
import CustomChart from "./CustomChart";

class Contacts extends Component {


  constructor(props) {

    super(props);

    this.state = {
      count: 0,
      selectedOptions: 0,
      company: "All",
      loading: false,
      search: "",
      companySearch: [],
      name: "",
      customerlist: [],
      selectAllLabel: [],
      PreValueSelected: [],
      valueSelected: [],
      description: "",
      customer: "",
      campManagerFirstName: "",
      campManagerLastName: "",
      campAdminFirstName: "",
      campAdminLastName: "",
      linkedInProfile: "",
      status: "",
      selectedCampaignStatus: "",
      campaignid: 0,
      connectionsToBeSent: "",
      startDate: "",
      startTime: "",
      steps: [],
      show: false,
      DashboardData2: {
        TotalSent: 0,
        TotalConnection: 0,
        TotalEngagedCon: 0,
        TotalLeadsCon: 0,

        step1: 0,
        step2: 0,
        step3: 0,
        step4: 0,
        step5: 0,

        step2Remain: 0,
        step3Remain: 0,
        step4Remain: 0,
        step5Remain: 0,
        step2Remain1st: 0,

        stepLength: 0,
        TotalConnectRate: "",
        LiveConnectRate: "",
        TotalEngaged: "",
        LiveEngaged: "",
        TotalLeads: "",
        LiveLeads: "",
        newRecentdata: "",
        recentLeads: [],
        recentcontactCount: [],
        selectedOptions: [],

      }
    };
  }

  componentDidMount() {
    this.SearchCompany();
    this.setState({ loading: true }, () => {
      this.getDashboardData2();
    });
  }


  SearchCompany = () => {
    //var bb = localStorage.getItem("customer");
    //var c = bb;

    var dasId = 0;
    if (localStorage.getItem("role") === "CUSTOMER") {
      dasId = localStorage.getItem("customer");
    } else {
      dasId = localStorage.getItem("id");
    }


    fetch(
      // `${API_URL}/api/Contactscompanies/getCompanyResp?searchValue=${this.state.search}`,
      // `${API_URL}/api/Contacts/getCompanyResp?searchValue=${this.state.search}&userid=${localStorage.getItem("id")}&role=${localStorage.getItem("role")}`,
      `${API_URL}/api/Contacts/getCompanyResp?searchValue=${this.state.search}&userid=${dasId}&role=${localStorage.getItem("role")}`,
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-type": "application/json"
        }
      }
    )
      .then(res => res.json())
      .then(res => {

        this.setState(
          {
            customerlist: res
          }
        
        );
      })
      .catch(e => {
        console.log(e);
      });
  };



  toggleSelectAllRow = isChecked => {
    if (isChecked) {
      this.gettingAllDataFromQuery();
    } else {
      this.setState({
        selectAll: false,
        selectedArray: [],
        selected: {}
      });
    }
  };
  gettingAllDataFromQuery = () => {

  };

  handleChange2 = event => {

    this.setState({ search: event.target.value }, () => {
      if (this.state.search !== "") {
        this.setState(
          {
            searchFlag: true
          },
          () => {
            this.onSearchClick();
          }
        );
      } else {
        this.setState(
          {
            searchFlag: false
          },
          () => {
            this.onSearchClick();
          }
        );
      }
    });
  };
 
  selectListChange = (event, v) => {

    if (v !== undefined && v !== null) {

      var searchVar = [];
      v.map(data => {

        searchVar.push({ name: (data.name.split('&')[0]).trim(), id: data.id })
      });

      this.setState(
        {
          company: "",
          search: ""
        },
        () => {
          this.setState(
            {
              companySearch: searchVar,
           
              flag: true,
              searchFlag: true
            }
            ,
            () => {
              this.getDashboardData2();
            }
          );
        }
      );
    } else {
      this.setState({
        company: "All",
        ManagerId: undefined,
        ManagerId1: "All",
      });
    }
  };



  onSearchClick = () => {

    if (this.state.searchFlag === true) {

      this.setState({ clickToSearch: true }, () => {

        this.SearchCompany();
        this.getDashboardData2();
      });
    } else {

      this.setState({ clickToSearch: false }, () => {
        this.SearchCompany();
        this.getDashboardData2();
      });
    }
  };
  
  convertArrayToObject = selectedArrayIds => {
    let SelectedIds = [];
    selectedArrayIds.map(item => {
      return SelectedIds.push({ name: item });
    });
    return SelectedIds;
  };
  getDashboardData2 = (data) => {

    var dasId = 0;
    if (localStorage.getItem("role") === "CUSTOMER") {
      dasId = localStorage.getItem("customer");
    } else {
      dasId = localStorage.getItem("id");
    }

    let selectedArrayIds = [];
    var selectedArray = this.state.companySearch;

    if (selectedArray.length === 0 && this.state.search !== "") {
      selectedArrayIds.push({ name: this.state.search });
    }

    selectedArray.map(a => {

      return selectedArrayIds.push({ name: a.name });
    });

    let searchData = [];
    if (selectedArray.length > 0) {
      searchData = JSON.stringify(selectedArrayIds);
    }
    if (selectedArray.length === 0 && this.state.search !== "") {
      searchData = JSON.stringify(selectedArrayIds);
    }


    // this.state.search
    fetch(

      //http://localhost:4000/api/Campaigns/getContactHomeDas?role=SADMIN&userid=185&search=cloudr
      //`${API_URL}/api/Campaigns/getContactHomeDas?role=${localStorage.getItem("role")}&userid=${localStorage.getItem("id")}&search=${cleanText}&access_token=${localStorage.getItem("token")}`,
      `${API_URL}/api/Campaigns/getContactHomeDas?role=${localStorage.getItem("role")}&userid=${dasId}&search=${searchData}&access_token=${localStorage.getItem("token")}`,

      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-type": "application/json"
        }
      }
    )
      .then(res => res.json())
      // .then(res => {

      .then(res => {



        this.setState(
          {
            DashboardlistData2: res.response
          },
          () => {
            this.setDataCalculation2();
          }
        );
      })
      .catch(e => {
        console.log(e);
      });
    // });
  };

  setDataCalculation2 = () => {



    const { DashboardlistData2, DashboardData2 } = this.state;

    var engData = "0";
    var leadData = "0";
    var connectData = "0";

    if (DashboardlistData2[1].engagedRate != null) {
      engData = DashboardlistData2[1].engagedRate.toFixed(0);
    }
    if (DashboardlistData2[2].leadsRate != null) {
      leadData = DashboardlistData2[2].leadsRate.toFixed(0);
    }
    if (DashboardlistData2[0].connectRate != null) {
      connectData = DashboardlistData2[0].connectRate.toFixed(0);
    }
    DashboardData2.TotalSent = DashboardlistData2[3];
    DashboardData2.TotalConnection = DashboardlistData2[6];
    DashboardData2.TotalEngagedCon = DashboardlistData2[5];
    DashboardData2.TotalLeadsCon = DashboardlistData2[4];
    DashboardData2.TotalEngaged = engData;
    DashboardData2.TotalLeads = leadData;
    DashboardData2.TotalConnectRate = connectData;
    DashboardData2.recentLeads = DashboardlistData2[7];
    DashboardData2.recentTrigger = DashboardlistData2[8];
    DashboardData2.recentNoop = DashboardlistData2[13];
    DashboardData2.recentContact = DashboardlistData2[14];
    DashboardData2.stepLength = DashboardlistData2[12].stepContacts.length;
    var TotalLength = DashboardlistData2[12].stepContacts.length;
    var flag = 0;



    for (var i = 0; i < TotalLength; i++) {

      var index = i + flag;

      var name = DashboardlistData2[12].stepContacts[i].stepname;


      if (name === "VISIT") {
        name = "Visit";
      }
      if (name === "FOLLOW") {
        name = "Follow";
      }
      if (name === "SEND_INVITE") {
        name = "Connections";
      }
      if (name === "SEND_THANKS_MESSAGE") {
        name = "Thank You Message";
      }
      if (name === "SEND_MESSAGE") {
        name = "Send Message";
      }
      if (name === "SEND_EMAIL") {
        name = "Send Inmail";
      }




      if (i === 0 && (DashboardlistData2[12].stepContacts[0].stepname === "SEND_EMAIL" || DashboardlistData2[12].stepContacts[0].stepname === "SEND_MESSAGE")) {
        DashboardData2.stepLength = DashboardData2.stepLength + 1;

        DashboardData2.step1 =
          DashboardlistData2[15];
        DashboardData2.stepname1 = "Connections";
        flag = 1;

        DashboardData2.step2 = DashboardlistData2[12].stepContacts[0].totalCount;
        DashboardData2.stepname2 = name;
        DashboardData2.step2Remain1st = (DashboardlistData2[15]) - (DashboardlistData2[12].stepContacts[0].totalCount);
      }
      else {
        switch (index) {

          case 0:
            DashboardData2.step1 = DashboardData2.TotalConnection;
            DashboardData2.stepname1 = "Connections";


            break;
          case 1:
            DashboardData2.step2 =
              DashboardlistData2[12].stepContacts[i].totalDone;
            DashboardData2.stepname2 = name;
            DashboardData2.step2Remain = DashboardlistData2[12].stepContacts[i].totalPen;
            break;
          case 2:
            DashboardData2.step3 =
              DashboardlistData2[12].stepContacts[i].totalDone;
            DashboardData2.stepname3 = name;
            DashboardData2.step3Remain = DashboardlistData2[12].stepContacts[i].totalPen + DashboardData2.step2Remain;
            break;
          case 3:
            DashboardData2.step4 =
              DashboardlistData2[12].stepContacts[i].totalDone;
            DashboardData2.stepname4 = name;
            DashboardData2.step4Remain = DashboardlistData2[12].stepContacts[i].totalPen + DashboardData2.step3Remain;
            break;

          case 4:
            DashboardData2.step5 =
              DashboardlistData2[12].stepContacts[i].totalDone;
            DashboardData2.stepname5 = name;
            DashboardData2.step5Remain = DashboardlistData2[12].stepContacts[i].totalPen + DashboardData2.step4Remain;
            break;
        }
      }

    }


    this.setState({
      DashboardlistData2,
      loading: false
    });
  };

  render() {

    if (this.state.loading) {
      return (
        <div className="spinner">
          <SemipolarLoading size={70} color={"#3865dd"} />
        </div>
      );
    }


    // const options = {
    //   animations: {
    //     y: {
    //       easing: "easeInOutElastic",
    //       from: ctx => {
    //         if (ctx.type === "data") {
    //           if (ctx.mode === "default" && !ctx.dropped) {
    //             ctx.dropped = true;
    //             return 0;
    //           }
    //         }
    //       }
    //     }
    //   },
    //   plugins: {
    //     filler: {
    //       propagate: true
    //     }
    //   },

    // };


    const labels = [];
    const countryCount = [];
    const countryDetail = [];


    if (this.state.DashboardlistData2 !== undefined) {

      var datacount = this.state.DashboardlistData2[9];
      var totalCountryCount = this.state.DashboardlistData2[10];

      for (var i = 0; i < datacount.length; i++) {

        var countryPer = ((datacount[i].countryCount / totalCountryCount) * 100).toFixed(0);
        var countryName= datacount[i].country !="" ? datacount[i].country : "TBD";
        if (countryPer !== "0") {
          labels.push(countryName);
          countryCount.push(datacount[i].countryCount);
          }
      }


    }


    // function transparentize(value, opacity) {
    //   var alpha = opacity === undefined ? 0.5 : 1 - opacity;
    //   return colorLib(value)
    //     .alpha(alpha)
    //     .rgbString();
    // }


    
    // var nnj = countryDetail[0]
    const data2 = [
      ["Task", "Hours per Day"],
      [labels[0], countryCount[0]],
      [labels[1], countryCount[1]],
      [labels[2], countryCount[2]],
      [labels[3], countryCount[3]],
      [labels[4], countryCount[4]],
      [labels[5], countryCount[5]],
      [labels[6], countryCount[6]],
      [labels[7], countryCount[7]],
      [labels[8], countryCount[8]],
      [labels[9], countryCount[9]],
      [labels[10], countryCount[10]],
      [labels[11], countryCount[11]],
      [labels[12], countryCount[12]],
      [labels[13], countryCount[13]],
      [labels[14], countryCount[14]],
      [labels[15], countryCount[15]],
      [labels[16], countryCount[16]],
      [labels[17], countryCount[17]],
      [labels[18], countryCount[18]],
      [labels[19], countryCount[19]],
      [labels[20], countryCount[20]],
      [labels[21], countryCount[21]],
      [labels[22], countryCount[22]],
      [labels[23], countryCount[23]],
      [labels[24], countryCount[24]],
      [labels[25], countryCount[25]],
      [labels[26], countryCount[26]],
      [labels[27], countryCount[27]],
      [labels[28], countryCount[28]],
      [labels[29], countryCount[29]],
      [labels[30], countryCount[30]],


    ];
    const options2 = {
      title: "Country wise Percentage data",
    };
    // const type = "line";
    const datasets = [
      {
        label: '# of Votes',
        data: countryCount,
      
        backgroundColor: [

          "rgba(229,43,80,1)",
          "rgba(255,191,0,1)",
          "rgba(153,102,204,1)",
          "rgba(251,206,177,1)",
          "rgba(127,255,212,1)",
          "rgba(0,127,255,1)",
          "rgba(137,207,240,1)",
          "rgba(245,245,220,1)",
          "rgba(203,65,84,1)",
          // "rgba(0,0,0,1)",
          "rgba(0,0,255,1)",
          "rgba(0,149,182,1)",
          "rgba(138,43,226,1)",
          "rgba(222,93,131,1)",
          "rgba(205,127,50,1)",
          "rgba(153,51,0,1)",
          "rgba(128,0,32,1)",
          "rgba(112,41,99,1)",
          "rgba(150,0,24,1)",
          "rgba(222,49,99,1)",
          "rgba(0,123,167,1)",
          "rgba(247,231,206,1)",
          "rgba(127,255,0,1)",
          "rgba(123,63,0,1)",
          "rgba(0,71,171,1)",
          "rgba(111,78,55,1)",
          "rgba(184,115,51,1)",
          "rgba(255,127,80,1)",
          "rgba(220,20,60,1)",
          "rgba(0,255,255,1)",
          "rgba(237,201,175,1)",
          "rgba(125,249,255,1)",
          "rgba(80,200,120,1)",
          "rgba(0,255,63,1)",
          "rgba(255,215,0,1)",
          "rgba(190,190,190,1)",
          "rgba(0,128,1,1)",
          "rgba(63,255,0,1)",
          "rgba(75,0,130,1)",
          "rgba(255,255,240,1)",
          "rgba(0,168,107,1)",
          "rgba(41,171,135,1)",
          "rgba(181,126,220,1)",
          "rgba(255,247,0,1)",
          "rgba(200,162,200,1)",
          "rgba(191,255,0,1)",
          "rgba(255,0,255,1)",
          "rgba(255,0,175,1)",
          "rgba(128,0,0,1)",
          "rgba(224,176,255,1)",
          "rgba(0,0,128,1)",
          "rgba(204,119,34,1)",
          "rgba(128,128,0,1)",
          "rgba(255,102,0,1)",
          "rgba(255,69,0,1)",
          "rgba(218,112,214,1)",
          "rgba(255,229,180,1)",
          "rgba(209,226,49,1)",
          "rgba(204,204,255,1)",
          "rgba(28,57,187,1)",
          "rgba(255,192,203,1)",
          "rgba(142,69,133,1)",
          "rgba(0,49,83,1)",
          "rgba(204,136,153,1)",
          "rgba(106,13,173,1)",
          "rgba(227,11,92,1)",
          "rgba(255,0,0,1)",
          "rgba(199,21,133,1)",
          "rgba(255,0,127,1)",
          "rgba(224,17,95,1)",
          "rgba(250,128,114,1)",
          "rgba(146,0,10,1)",
          "rgba(15,82,186,1)",
          "rgba(255,36,0,1)",
          "rgba(192,192,192,1)",
          "rgba(112,128,144,1)",
          "rgba(167,252,0,1)",
          "rgba(0,255,127,1)",
          "rgba(210,180,140,1)",
          "rgba(72,60,50,1)",
          "rgba(0,128,128,1)",
          "rgba(64,224,208,1)",
          "rgba(63,0,255,1)",
          "rgba(128,0,255,1)",
          "rgba(64,130,109,1)",
          "rgba(255,255,255,1)",
          "rgba(255,255,0,1)",
          "rgba(240,248,255,1)",
          "rgba(229,43,80,1)",
          "rgba(255,191,0,1)",
          "rgba(153,102,204,1)",
          "rgba(251,206,177,1)",
          "rgba(127,255,212,1)",
          "rgba(0,127,255,1)",
          "rgba(137,207,240,1)",
          "rgba(245,245,220,1)",
          "rgba(203,65,84,1)",
          // "rgba(0,0,0,1)",
          "rgba(0,0,255,1)",
          "rgba(0,149,182,1)",
          "rgba(138,43,226,1)",
          "rgba(222,93,131,1)",
          "rgba(205,127,50,1)",
          "rgba(153,51,0,1)",
          "rgba(128,0,32,1)",
          "rgba(112,41,99,1)",
          "rgba(150,0,24,1)",
          "rgba(222,49,99,1)",
          "rgba(0,123,167,1)",
          "rgba(247,231,206,1)",
          "rgba(127,255,0,1)",
          "rgba(123,63,0,1)",
          "rgba(0,71,171,1)",
          "rgba(111,78,55,1)",
          "rgba(184,115,51,1)",
          "rgba(255,127,80,1)",
          "rgba(220,20,60,1)",
          "rgba(0,255,255,1)",
          "rgba(237,201,175,1)",
          "rgba(125,249,255,1)",
          "rgba(80,200,120,1)",
          "rgba(0,255,63,1)",
          "rgba(255,215,0,1)",
          "rgba(190,190,190,1)",
          "rgba(0,128,1,1)",
          "rgba(63,255,0,1)",
          "rgba(75,0,130,1)",
          "rgba(255,255,240,1)",
          "rgba(0,168,107,1)",
          "rgba(41,171,135,1)",
          "rgba(181,126,220,1)",
          "rgba(255,247,0,1)",
          "rgba(200,162,200,1)",
          "rgba(191,255,0,1)",
          "rgba(255,0,255,1)",
          "rgba(255,0,175,1)",
          "rgba(128,0,0,1)",
          "rgba(224,176,255,1)",
          "rgba(0,0,128,1)",
          "rgba(204,119,34,1)",
          "rgba(128,128,0,1)",
          "rgba(255,102,0,1)",
          "rgba(255,69,0,1)",
          "rgba(218,112,214,1)",
          "rgba(255,229,180,1)",
          "rgba(209,226,49,1)",
          "rgba(204,204,255,1)",
          "rgba(28,57,187,1)",
          "rgba(255,192,203,1)",
          "rgba(142,69,133,1)",
          "rgba(0,49,83,1)",
          "rgba(204,136,153,1)",
          "rgba(106,13,173,1)",
          "rgba(227,11,92,1)",
          "rgba(255,0,0,1)",
          "rgba(199,21,133,1)",
          "rgba(255,0,127,1)",
          "rgba(224,17,95,1)",
          "rgba(250,128,114,1)",
          "rgba(146,0,10,1)",
          "rgba(15,82,186,1)",
          "rgba(255,36,0,1)",
          "rgba(192,192,192,1)",
          "rgba(112,128,144,1)",
          "rgba(167,252,0,1)",
          "rgba(0,255,127,1)",
          "rgba(210,180,140,1)",
          "rgba(72,60,50,1)",
          "rgba(0,128,128,1)",
          "rgba(64,224,208,1)",
          "rgba(63,0,255,1)",
          "rgba(128,0,255,1)",
          "rgba(64,130,109,1)",
          "rgba(255,255,255,1)",
          "rgba(255,255,0,1)",
          "rgba(240,248,255,1)",

        ],
 
        borderWidth: 1,
      },
    ];
  
    const data = {
      labels,
      datasets
    };



    // var cc = this.state.DashboardlistData2;
    // var today = new Date();
    // var curHr = today.getHours();

    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;

    const onNameClick = row => {

      this.props.onHandleCampaign(row);
      localStorage.setItem("label", "Leads");
      localStorage.setItem("path", "/campaigns");

    };
    const onNameClick2 = row => {

      this.props.onHandleCampaign(row);
      localStorage.setItem("label", "Trigger");
      localStorage.setItem("path", "/campaigns");

    };

    const allSelected = this.state.customerlist.length === this.state.selectedOptions.length;
   
    const handleSelectAll = isSelected => {
      if (isSelected) {
      } else {
      }
    };
    const filter = createFilterOptions();


    const handleToggleSelectAll = () => {
      handleSelectAll && handleSelectAll(!allSelected);
    };
    const handleChange = (event, selectedOptions, reason) => {

      var All2 = false;
      var preData = this.state.PreValueSelected;

      if (preData.length !== 0 && selectedOptions.length !== 0) {
               if (selectedOptions[selectedOptions.length - 1].name !== "Select All" && reason === "selectOption" && selectedOptions.length !== 16) {
         
          this.setState({
            valueSelected: selectedOptions,
            PreValueSelected: selectedOptions

          })
        }
        else {

          //var bb = this.state.search;
          if (preData[preData.length - 1].name === "Select All" && selectedOptions[selectedOptions.length - 1].name === "Select All") {

            this.setState({
              PreValueSelected: [],
              valueSelected: []
            })
          } else {
            this.setState({
              PreValueSelected: selectedOptions
            })

            if (reason === "selectOption" || reason === "removeOption") {
              this.setState({
                PreValueSelected: selectedOptions
              })
              if (selectedOptions[selectedOptions.length - 1].name === "Select All") {

                if (reason === "selectOption") {

                  handleToggleSelectAll();

                  let result = [];
                  result = this.state.customerlist.filter(el => el.value !== "Select All");

                  this.setState({
                    valueSelected: result
                  })
                }
                else {

                  var selectArr = [];
                  if (event._targetInst.alternate.key === "Select All") {

                    selectArr = []
                  } else {
                    selectArr = selectedOptions
                  }
                  this.setState({
                    valueSelected: selectArr
                  })
                }



              } else {


                this.setState({
                  valueSelected: selectedOptions
                })
              }
            } else if (reason === "clear") {


              this.setState({
                valueSelected: []
              })
            }
          }
        }
      } else {

        if (reason === "selectOption" || reason === "removeOption") {
          if (preData === "Select All" && event.target.innerText === "Select All") {
            this.setState({
              PreValueSelected: []
            })
          } else {
            this.setState({
              PreValueSelected: selectedOptions,
              valueSelected: selectedOptions
            })

            if (selectedOptions.length > 0) {
              if (selectedOptions.length === 1 && selectedOptions[selectedOptions.length - 1].name === "Select All") {
                if (reason === "selectOption") {
                  All2 = true;

                  handleToggleSelectAll();
                  let result = [];
                  result = this.state.customerlist.filter(el => el.value !== "Select All");

                  this.setState({
                    valueSelected: result
                  })
                } else {

                  var selectArr = [];
                  if (event._targetInst.alternate.key === "Select All") {

                    selectArr = []
                  } else {

                    selectArr = selectedOptions

                  }
                  this.setState({
                    valueSelected: selectArr
                  })
                }
              }

            } else {
              this.setState({
                valueSelected: selectedOptions
              })
            }
          }

        } else if (reason === "clear") {

          this.setState({
            valueSelected: [],
            customerlist: [],

          })
          this.SearchCompany();
        }
      }



      var flag = false;

      if (reason !== "clear") {
        if (event.target.innerText === "Select All" && selectedOptions.length > 1 && selectedOptions.length < 16 && this.state.customerlist.length === 15) {
          flag = true;
        }

        else if (
          event.target.innerText === "Select All" && selectedOptions.length === 1 && this.state.customerlist.length === 15
        ) {
          flag = true;
        }

        else if (
          event.target.innerText === "Select All" && selectedOptions.length === 16
        ) {
          flag = true;
        } else if (
          event.target.innerText === "Select All" && this.state.customerlist.length < 15
        ) {
          flag = false;
        }

        else if (
          All2 === true && selectedOptions.length === 1 && this.state.customerlist.length === 15
        ) {
          flag = true;
        }


        else if (
          selectedOptions.length === 16 && this.state.customerlist.length === 15
        ) {
          flag = true;
        }
        if (selectedOptions.length > 0) {
          if (selectedOptions[selectedOptions.length - 1].name === "Select All" && selectedOptions.length > 1 && selectedOptions.length < 16 && this.state.customerlist.length === 15) {
            flag = true;
          }
        }

      }

      var select = "";
      if (selectedOptions.length > 0) {
        select = selectedOptions[selectedOptions.length - 1].name
      }


      if (selectedOptions !== undefined && selectedOptions !== null && flag === false) {

        var searchVar = [];

        if (select === "Select All") {
          selectedOptions = this.state.customerlist;
        }
        if (selectedOptions.length === 1 && event.target.innerText === "Select All") {
          selectedOptions = this.state.customerlist;
        }

        selectedOptions.map(data => {

          searchVar.push({ name: (data.name.split('&')[0]).trim(), id: data.id })
        });

        this.setState(
          {
            company: "",
            search: ""
          },
          () => {
            this.setState(
              {
                companySearch: searchVar,
                flag: true,
                searchFlag: true
              }
              ,
              () => {
                this.getDashboardData2();
              }
            );
          }
        );
      } else {
        this.setState(
          {
            company: "",
            search: ""
          },
          () => {
            this.setState(
              {
                companySearch: [],
                flag: true,
                searchFlag: true
              }
              ,
              () => {
                this.getDashboardData2();
              }
            );
          }
        );
      }
    };





    const getOptionLabel = option => `${option.key}`;
    // const optionRenderer = (option, { selected }) => {

    //   const selectAllProps =
    //     option.key === "select-all" // To control the state of 'select-all' checkbox
    //       ? { checked: allSelected }
    //       : {};
    //   return (
    //     <>
    //       <Checkbox
    //         color="primary"
    //         icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
    //         checkedIcon={<CheckBoxIcon fontSize="small" />}
    //         style={{ marginRight: 8 }}
    //         checked={selected}
    //         {...selectAllProps}
    //       />
    //       {getOptionLabel(option)}
    //     </>
    //   );
    // };
    return (



      <div className="homePageSection">
        <div className="gridContainer">
          <div className="greetFlexBox">

          </div>
        </div>

        <div className="main_campaign">
          <div className="main_right">
            <div className="Clients">
              <div className="Contacts">
                <div className="modalButton-flex">
                  <div className="allFiltersField">
                    <div className="statusDiv"> Company name</div>

                    <div className="searchDiv">

                      <Autocomplete
                        multiple
                        limitTags={3}
                        disableCloseOnSelect
                        options={this.state.customerlist ? this.state.customerlist : []}
                        getOptionLabel={(option) => option.name}
                        getOptionSelected={(option, value) => option.value === value.value}
                        onChange={handleChange}
                        value={this.state.valueSelected}




                        filterOptions={(options, params) => {
                          const filtered = filter(options, params);
                          return [{ name: "Select All" }, ...filtered];
                        }}

                        renderOption={(props, option, { selected }) => (

                          <li {...props}>

                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option.name}
                          </li>

                        )}
                     
                        renderInput={params => (
                          <TextField

                            {...params}
                            value={null}
                            InputProps={{
                              ...params.InputProps,


                            }}
                            fullWidth
                            InputLabelProps={{
                              shrink: true
                            }}

                            onChange={this.handleChange2}

                            onKeyDown={this.onSearchKeyDown}
                            inputProps={{
                              ...params.inputProps
                            }}
                          />
                        )}
                   
                        sx={{ width: '500px' }}
                      />
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div className="campaign_data">




              {this.state.DashboardlistData2 !== undefined && this.state.DashboardlistData2[12].stepContacts[0] ? (

                < div className="campaign_data_stats0_C ">
                  {this.state.DashboardlistData2[12].stepContacts[0].stepname === "SEND_EMAIL" || this.state.DashboardlistData2[12].stepContacts[0].stepname === "SEND_MESSAGE" && (
                    <div className="campaign_data_stats">
                      <div className="data_stats_card2">
                        <div>
                          <h2>
                            {this.state.DashboardData2.step1}{" "}
                          </h2>{" "}
                          <p>
                            {" "}
                            <p></p> Total Connections
                          </p>
                        </div>

                        <div className="icons">
                          <img src={ConnectRateIcon} alt="users" />
                        </div>
                      </div>

                      <div className="data_stats_card2">
                        <div>
                          <h2>
                            {((this.state.DashboardData2.step2 / this.state.DashboardData2.step1) * 100).toFixed(0)}% (
                            {this.state.DashboardData2.step2}){" "}
                          </h2>
                          <p>Message Sent</p>
                        </div>
                        <div className="icons">
                          <img src={TotalinvitesentIcon} alt="users" />
                        </div>
                      </div>

                      <div className="data_stats_card2">
                        <div>
                          <h2>
                            {((this.state.DashboardData2.TotalEngagedCon / this.state.DashboardData2.step2) * 100).toFixed(0)}% (
                            {this.state.DashboardData2.TotalEngagedCon})
                          </h2>
                          <p>Total Engaged</p>
                        </div>
                        <div className="icons">
                          <img src={TotalEngagedIcon} alt="users" />
                        </div>
                      </div>
                      <div className="data_stats_card2">
                        <div>
                          <h2>
                            {((this.state.DashboardData2.TotalLeadsCon / this.state.DashboardData2.step2) * 100).toFixed(0)}% (
                            {this.state.DashboardData2.TotalLeadsCon})
                          </h2>
                          <p>Total Leads</p>
                        </div>
                        <div>
                          <h2>
                            {" "}
                            <div className="icons">
                              <img src={TotalLeadIcon} alt="users" />
                            </div>
                          </h2>
                        </div>
                      </div>
                    </div>
                  )}

                  {this.state.DashboardlistData2[12].stepContacts[0].stepname !== "SEND_EMAIL" && this.state.DashboardlistData2[12].stepContacts[0].stepname !== "SEND_MESSAGE" && (
                    <div className="campaign_data_stats">
                      <div className="data_stats_card2">
                        <div>
                          <h2>{this.state.DashboardData2.TotalSent}</h2>
                          <p>Invitation Sent</p>
                        </div>
                        <div className="icons">
                          <img src={TotalinvitesentIcon} alt="users" />
                        </div>
                      </div>
                      <div className="data_stats_card2">
                        <div>
                          <h2>
                            {this.state.DashboardData2.TotalConnectRate}% (
                            {this.state.DashboardData2.TotalConnection}){" "}
                          </h2>{" "}
                          <p>
                            {" "}
                            <p></p> Total Connections
                          </p>
                        </div>

                        <div className="icons">
                          <img src={ConnectRateIcon} alt="users" />
                        </div>
                      </div>
                      <div className="data_stats_card2">
                        <div>
                          <h2>
                            {this.state.DashboardData2.TotalEngaged}% (
                            {this.state.DashboardData2.TotalEngagedCon})
                          </h2>
                          <p>Total Engaged</p>
                        </div>
                        <div className="icons">
                          <img src={TotalEngagedIcon} alt="users" />
                        </div>
                      </div>
                      <div className="data_stats_card2">
                        <div>
                          <h2>
                            {this.state.DashboardData2.TotalLeads}% (
                            {this.state.DashboardData2.TotalLeadsCon})
                          </h2>
                          <p>Total Leads</p>
                        </div>
                        <div>
                          <h2>
                            {" "}
                            <div className="icons">
                              <img src={TotalLeadIcon} alt="users" />
                            </div>
                          </h2>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="campaign_data_stats0">
                  <div className="campaign_data_stats">
                    <div className="data_stats_card2">
                      <div>

                        <h2>{this.state.DashboardData2.TotalSent}</h2>
                        <p>Invitation Sent</p>
                      </div>
                      <div className="icons">
                        <img src={TotalinvitesentIcon} alt="users" />
                      </div>
                    </div>
                    <div className="data_stats_card2">
                      <div>
                        <h2>
                          {this.state.DashboardData2.TotalConnectRate}% (
                          {this.state.DashboardData2.TotalConnection}){" "}
                        </h2>{" "}
                        <p>
                          {" "}
                          <p></p> Total Connections
                        </p>
                      </div>

                      <div className="icons">
                        <img src={ConnectRateIcon} alt="users" />
                      </div>
                    </div>
                    <div className="data_stats_card2">
                      <div>
                        <h2>
                          {this.state.DashboardData2.TotalEngaged}% (
                          {this.state.DashboardData2.TotalEngagedCon})
                        </h2>
                        <p>Total Engaged</p>
                      </div>
                      <div className="icons">
                        <img src={TotalEngagedIcon} alt="users" />
                      </div>
                    </div>
                    <div className="data_stats_card2">
                      <div>
                        <h2>
                          {this.state.DashboardData2.TotalLeads}% (
                          {this.state.DashboardData2.TotalLeadsCon})
                        </h2>
                        <p>Total Leads</p>
                      </div>
                      <div>
                        <h2>
                          {" "}
                          <div className="icons">
                            <img src={TotalLeadIcon} alt="users" />
                          </div>
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>)}


                {this.state.DashboardlistData2 !== undefined && (
                  <CustomChart data={data2} options={options2} />
              )}


              <div className="campaign_recent_Contact">
                {this.state.DashboardlistData2 !== undefined && (
                  <div className="campaign_recent">
                    <div className="campaign_recent_jobsContact2">
                      <h2 className="title" onClick={() => onNameClick(this.state)} > Contacts</h2>

                      <div>
                        <ContactsCard DashboardData={this.state.DashboardlistData2} />
                      </div>
                    </div>
                  </div>)}

              </div>

            </div>
            {this.state.DashboardlistData2 !== undefined && (

              <div className="campaign_recent">
                <div className="campaign_recent_jobsContact">
                  <h2 className="title" onClick={() => onNameClick(this.state)} > Engagements</h2>

                  <div>
                    <EngagementCard DashboardData={this.state.DashboardlistData2} />
                  </div>
                </div>
                <div className="campaign_recent_jobsContact">
                  <h2 className="title" onClick={() => onNameClick(this.state)} > Leads</h2>

                  <div>
                    <LeadsCard DashboardData={this.state.DashboardlistData2} />
                  </div>
                </div>
                <div className="campaign_recent_jobsContact">
                  <h2 className="title" onClick={() => onNameClick2(this.state)} >Triggers</h2>
                  <TriggersCard DashboardData={this.state.DashboardlistData2} />
                </div>

              </div>
            )}
          </div>
        </div>
      </div>
    );

  }

};
const mapDispatchToProps = dispatch => {

  return {
    onHandleCampaign: data =>
      dispatch({
        type: "Campaign_Detail",
        payload: data
      })
  };
};
export default connect(null, mapDispatchToProps)(Contacts);
